import type Item from 'owa-service/lib/contract/Item';
import {
    IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME,
    PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME,
    PROACTIVE_DRAFT_PROPERTY_SET_ID,
} from './constants';
import type { ProactiveDraftGenerationProperties } from './types';

function parseGenerationProperties(raw: string): ProactiveDraftGenerationProperties | undefined {
    let parsed: {
        conversationId?: unknown;
        requestId?: unknown;
        createdDateTime?: unknown;
    };
    try {
        parsed = JSON.parse(raw);
    } catch {
        return undefined;
    }
    if (!parsed || typeof parsed !== 'object') {
        return undefined;
    }
    return {
        sydneyConversationId:
            typeof parsed.conversationId === 'string' ? parsed.conversationId : undefined,
        requestId: typeof parsed.requestId === 'string' ? parsed.requestId : undefined,
        createdDateTime:
            typeof parsed.createdDateTime === 'string' ? parsed.createdDateTime : undefined,
    };
}

export default function extractProactiveDraftFields(item: Item): {
    IsCopilotProactiveDraft?: boolean;
    ProactiveDraftGenerationProperties?: ProactiveDraftGenerationProperties;
} {
    if (!item.ExtendedProperty) {
        return {};
    }
    let isCopilotProactiveDraft: boolean | undefined;
    let generationProperties: ProactiveDraftGenerationProperties | undefined;
    for (const prop of item.ExtendedProperty) {
        if (
            prop?.ExtendedFieldURI?.PropertySetId?.toLowerCase() !== PROACTIVE_DRAFT_PROPERTY_SET_ID
        ) {
            continue;
        }
        const name = prop.ExtendedFieldURI.PropertyName;
        if (
            name === IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME &&
            prop.ExtendedFieldURI.PropertyType === 'Boolean'
        ) {
            isCopilotProactiveDraft =
                prop.Value === true ||
                (typeof prop.Value === 'string' && prop.Value.toLowerCase() === 'true');
        } else if (
            name === PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME &&
            prop.ExtendedFieldURI.PropertyType === 'String' &&
            typeof prop.Value === 'string' &&
            prop.Value.length > 0
        ) {
            generationProperties = parseGenerationProperties(prop.Value);
        }
    }
    return {
        IsCopilotProactiveDraft: isCopilotProactiveDraft,
        ProactiveDraftGenerationProperties: generationProperties,
    };
}
